(function () {
  if(document.body.id !== 'top') return false

  //サブメニューを上部or下部へ
  var body = window.document.body;
  var html = window.document.documentElement;
  var header = document.querySelector('.js-header')
  var submenu = document.querySelectorAll('.js-nav-submenu')

  function scroll() {
    var scrollTop = body.scrollTop || html.scrollTop;
    if (scrollTop < window.innerHeight / 2 - header.clientHeight) {
      addSubmenuUp()
    } else {
      removeSubmenuUp()
    }
  }

  function addSubmenuUp() {
    for (var i = 0; i < submenu.length; i++) {
      submenu[i].classList.add('is-up')
    }
  }

  function removeSubmenuUp() {
    for (var i = 0; i < submenu.length; i++) {
      submenu[i].classList.remove('is-up')
    }
  }

  window.addEventListener('scroll', scroll)
  scroll()

}());
